import { Facet } from '../../models/Facet';
import { IOperationActionCreator, implementOperation } from '../../store/actions/implementOperation';

export const retryProgressItemsOperation: Facet<{}> = new Facet('retryProgressItemsOperation');

export const retryProgressItems: IOperationActionCreator<typeof retryProgressItemsOperation.type> = implementOperation({
  operationTypeFacet: retryProgressItemsOperation
});
